import BlogBox from './blogbox.js';

export default BlogBox;
